









import { Component, Prop, Vue } from "vue-property-decorator";
import { X_POINT, Y_AXIS_WIDTH, CHART_PADDING } from "./partografAxis";

@Component
export default class PartografTimeHeader extends Vue {
  @Prop({ default: () => [] }) jam!: Array<string>;

  yWidth = Y_AXIS_WIDTH;
  padRight = CHART_PADDING.right;

  get kolom(): Array<string> {
    const out: Array<string> = [];
    for (let i = 0; i <= X_POINT; i++) {
      if (i % 2 !== 0) {
        out.push("");
        continue;
      }
      const val = this.jam && this.jam[i] ? String(this.jam[i]).substr(0, 5) : "";
      out.push(val);
    }
    return out;
  }
}
